"use client";

import React, { Fragment, useState } from "react";

import { SupIconButton } from "@repo/core-ui";
import { SupCog } from "@repo/core-ui";

import Web3TxSettingsModal from "@/components/Web3/TxSettings/Dialog";
import Web3TxSettingsSlippage from "@/components/Web3/TxSettings/Slippage";

export default function Web3TxSettingsHandler() {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <Fragment>
      <div className="flex items-center space-x-2">
        <Web3TxSettingsSlippage onClick={() => setOpen(true)} />
        <SupIconButton onClick={() => setOpen(true)} className="h-5 duration-100 hover:bg-primary-75 hover:text-neutral-700 hover:ease-in">
          <SupCog />
        </SupIconButton>
      </div>
      <Web3TxSettingsModal open={open} setOpen={setOpen} />
    </Fragment>
  );
}
